import { PrimeReactStylesFunctionType } from '../types';
import { classNames } from 'primereact/utils';

/** Offset for the first toast only — avoids stacking gap when multiple toasts are visible. */
const TOAST_STACK_FIRST_MESSAGE_MARGIN_TOP = '45px';

export const ToastTailwindThemes = {
  toast: {
    root: {
      // PrimeReact sets the container z-index inline on show, but strips it again in its
      // `onExited` handler whenever another message is still on screen — leaving the visible
      // toast behind the app header. Pin PrimeReact's own default (`zIndex.toast`) here so the
      // stacking never depends on that inline style.
      className: classNames('w-96 max-w-86', 'z-[1200]', 'opacity-90'),
    },
    message: ({ state, index }: PrimeReactStylesFunctionType) => ({
      className: classNames('my-4 rounded-md w-full', {
        'bg-blue-100 text-blue-700': state.messages?.[index] && state.messages[index].message.severity == 'info',
        'bg-[#E7F3EE] text-[#195B53]': state.messages?.[index] && state.messages[index].message.severity == 'success',
        'bg-orange-100 text-orange-700': state.messages?.[index] && state.messages[index].message.severity == 'warn',
        'bg-[#FFE5E5] text-[#DD4F45]': state.messages?.[index] && state.messages[index].message.severity == 'error',
      }),
      style: index === 0 ? { marginTop: TOAST_STACK_FIRST_MESSAGE_MARGIN_TOP } : undefined,
    }),
    content: 'flex justify-start items-center p-5',
    icon: {
      className: 'hidden',
    },
    text: 'font-normal flex flex-col flex-1 grow shrink',
    summary: 'font-normal text-[0.875rem] block',
    detail: 'font-normal text-[0.875rem] leading-4.25',
    // Close button is opt-in: shown only when the toast message sets `closable: true`
    // (defaults to hidden). The X icon inherits the severity text colour via `currentColor`.
    closebutton: ({ state, index }: PrimeReactStylesFunctionType) => ({
      className: classNames(
        'flex items-center justify-center shrink-0 w-4 h-4 ml-3 p-0 bg-transparent border-0 cursor-pointer text-current transition-opacity',
        {
          hidden: !(state.messages?.[index] && state.messages[index].message.closable),
        },
      ),
    }),
    buttonicon: {
      className: 'w-[10px] h-[10px]',
    },
    transition: {
      enterFromClass: 'opacity-0 translate-x-0 translate-y-2/4 translate-z-0',
      enterActiveClass: 'transition-transform duration-300',
      leaveFromClass: 'max-h-40',
      leaveActiveClass: 'transition-all duration-500 ease-in',
      leaveToClass: 'max-h-0 opacity-0 mb-0 overflow-hidden',
    },
  },
};
